import { Monitor, Smartphone, Laptop, Check, Heart, Zap, ShoppingCart, GraduationCap, Factory, Store, Building, Plane, Plus, Layout, Globe, Database, TestTube, Cloud, Brain, Tablet, User, Shield, UserCircle, ShoppingBag, CreditCard, Bell, MessageCircle, Star, Calendar, FileText, Upload, Link, Mail, Bot, Video, MessageSquare, PhoneCall, DollarSign, Coins, Wallet, Apple } from 'lucide-react';

const platforms = [
    {
        id: 'web',
        title: 'Web Application',
        description: 'Build for desktop and browser experiences',
        icon: <Monitor size={32} className="option-icon" />
    },
    {
        id: 'mobile',
        title: 'Mobile Application',
        description: 'Create native mobile experiences',
        icon: <Smartphone size={32} className="option-icon" />
    },
    {
        id: 'both',
        title: 'Both Web and Mobile',
        description: 'Develop cross-platform solutions',
        icon: <Laptop size={32} className="option-icon" />
    }
];

const industries = [
    {
        id: 'healthcare',
        title: 'Healthcare',
        description: 'Medical, Health Tech, Telemedicine',
        icon: <Heart size={32} className="option-icon" />
    },
    {
        id: 'fintech',
        title: 'Fintech',
        description: 'Banking, Payments, Insurance',
        icon: <Zap size={32} className="option-icon" />
    },
    {
        id: 'ecommerce',
        title: 'E-Commerce',
        description: 'Online Store, Marketplace',
        icon: <ShoppingCart size={32} className="option-icon" />
    },
    {
        id: 'education',
        title: 'Education',
        description: 'EdTech, Learning Platform',
        icon: <GraduationCap size={32} className="option-icon" />
    },
    {
        id: 'manufacturing',
        title: 'Manufacturing',
        description: 'Production, Industrial',
        icon: <Factory size={32} className="option-icon" />
    },
    {
        id: 'retail',
        title: 'Retail',
        description: 'Physical Store, Consumer Goods',
        icon: <Store size={32} className="option-icon" />
    },
    {
        id: 'realestate',
        title: 'Real Estate',
        description: 'Property, Construction',
        icon: <Building size={32} className="option-icon" />
    },
    {
        id: 'travel',
        title: 'Travel & Hospitality',
        description: 'Tourism, Accommodation',
        icon: <Plane size={32} className="option-icon" />
    },
    {
        id: 'other',
        title: 'Other',
        description: 'Other',
        icon: <Plus size={32} className="option-icon" />
    }
];

const services = [
    {
        id: 'ui_ux',
        title: 'UI/UX Design',
        description: 'Professional interface design and user experience optimization',
        icon: <Layout size={32} className="option-icon" />
    },
    {
        id: 'web_dev',
        title: 'Web Development',
        description: 'Custom website and web application development',
        icon: <Globe size={32} className="option-icon" />
    },
    {
        id: 'mobile_dev',
        title: 'Mobile App Development',
        description: 'Native and cross-platform mobile application development',
        icon: <Smartphone size={32} className="option-icon" />
    },
    {
        id: 'backend',
        title: 'Backend/API Development',
        description: 'Robust server-side solutions and API architecture',
        icon: <Database size={32} className="option-icon" />
    },
    {
        id: 'qa_testing',
        title: 'QA & Testing',
        description: 'Comprehensive quality assurance and testing services',
        icon: <TestTube size={32} className="option-icon" />
    },
    {
        id: 'devops',
        title: 'DevOps / Deployment',
        description: 'Continuous integration and deployment solutions',
        icon: <Cloud size={32} className="option-icon" />
    },
    {
        id: 'ai_ml',
        title: 'AI/ML Integration',
        description: 'Artificial intelligence and machine learning implementation',
        icon: <Brain size={32} className="option-icon" />
    }
];

const devices = [
    {
        id: 'desktop',
        title: 'Desktop',
        description: '',
        icon: <Monitor size={32} className="option-icon" />
    },
    {
        id: 'mobile',
        title: 'Mobile',
        description: '',
        icon: <Smartphone size={32} className="option-icon" />
    },
    {
        id: 'tablet',
        title: 'Tablet/iPad',
        description: '',
        icon: <Tablet size={32} className="option-icon" />
    }
];

const mobileAppDevices = [
    {
        id: 'android_app',
        title: 'Android phones',
        description: '',
        icon: <Smartphone size={32} className="option-icon" />
    },
    {
        id: 'iphone',
        title: 'iPhones',
        description: '',
        icon: <Apple size={32} className="option-icon" />
    },
    {
        id: 'ipads',
        title: 'iPads/Tablets',
        description: '',
        icon: <Laptop size={32} className="option-icon" />
    }
];

const features = [
    {
        id: 'user_signup',
        title: 'User Login / SignUp',
        description: 'User authentication system',
        icon: <User size={32} className="option-icon" />
    },
    {
        id: 'otp_verification',
        title: 'OTP Verification',
        description: 'One-time password verification',
        icon: <Shield size={32} className="option-icon" />
    },
    {
        id: 'profile_management',
        title: 'Profile Management',
        description: 'User profile handling',
        icon: <UserCircle size={32} className="option-icon" />
    },
    {
        id: 'product_listing',
        title: 'Product Listing',
        description: 'Display products or services',
        icon: <ShoppingBag size={32} className="option-icon" />
    },
    {
        id: 'service_listing',
        title: 'Service Listing',
        description: 'Display available services',
        icon: <Layout size={32} className="option-icon" />
    },
    {
        id: 'booking_flow',
        title: 'Booking Flow (Product or Service)',
        description: 'Complete booking system',
        icon: <Calendar size={32} className="option-icon" />
    },
    {
        id: 'cart_checkout',
        title: 'Add to Cart / Checkout',
        description: 'Shopping cart functionality',
        icon: <ShoppingCart size={32} className="option-icon" />
    },
    {
        id: 'payment_processing',
        title: 'In-App Purchases',
        description: 'Payment processing system',
        icon: <CreditCard size={32} className="option-icon" />
    },
    {
        id: 'payment_gateway',
        title: 'Payment Gateway Integration',
        description: 'Third-party payment processing',
        icon: <Globe size={32} className="option-icon" />
    },
    {
        id: 'admin_panel',
        title: 'Admin Panel',
        description: 'Administrative dashboard',
        icon: <Layout size={32} className="option-icon" />
    },
    {
        id: 'push_notifications',
        title: 'Push Notifications',
        description: 'Real-time notifications',
        icon: <Bell size={32} className="option-icon" />
    },
    {
        id: 'chat_integration',
        title: 'Chat Integration (1:1 or Group)',
        description: 'Messaging functionality',
        icon: <MessageCircle size={32} className="option-icon" />
    },
    {
        id: 'channel_chat',
        title: 'Channel Chat or Broadcast',
        description: 'Group communication',
        icon: <MessageCircle size={32} className="option-icon" />
    },
    {
        id: 'live_streaming',
        title: 'Live Streaming or Video Integration',
        description: 'Video streaming capabilities',
        icon: <Globe size={32} className="option-icon" />
    },
    {
        id: 'rating_reviews',
        title: 'Rating / Reviews',
        description: 'User feedback system',
        icon: <Star size={32} className="option-icon" />
    },
    {
        id: 'scheduling',
        title: 'Scheduling / Calendar',
        description: 'Event management system',
        icon: <Calendar size={32} className="option-icon" />
    },
    {
        id: 'geolocation',
        title: 'Geolocation / Maps',
        description: 'Location-based features',
        icon: <Globe size={32} className="option-icon" />
    },
    {
        id: 'dashboard_analytics',
        title: 'Dashboard with Analytics',
        description: 'Data visualization',
        icon: <Layout size={32} className="option-icon" />
    },
    {
        id: 'file_upload',
        title: 'File Upload',
        description: 'Document management',
        icon: <Upload size={32} className="option-icon" />
    },
    {
        id: 'third_party_api',
        title: 'Third-party API Integration',
        description: 'External service integration',
        icon: <Link size={32} className="option-icon" />
    },
    {
        id: 'other',
        title: 'Other',
        description: 'Other',
        icon: <Plus size={32} className="option-icon" />
    }
];

const integrations = [
    {
        id: 'whatsapp',
        title: 'WhatsApp Integration',
        description: '',
        icon: <MessageCircle size={32} className="option-icon" />
    },
    {
        id: 'email',
        title: 'Email',
        description: '(SMTP or services like SendGrid)',
        icon: <Mail size={32} className="option-icon" />
    },
    {
        id: 'chatbot',
        title: 'Chatbot System',
        description: '',
        icon: <Bot size={32} className="option-icon" />
    },
    {
        id: 'crm',
        title: 'CRM (HubSpot, Zoho, etc.)',
        description: '',
        icon: <UserCircle size={32} className="option-icon" />
    },
    {
        id: 'video_streaming',
        title: 'Video/Streaming Platforms',
        description: '(Zoom, Vimeo, Agora, etc.)',
        icon: <Video size={32} className="option-icon" />
    },
    {
        id: 'sms',
        title: 'SMS Gateway',
        description: '',
        icon: <MessageSquare size={32} className="option-icon" />
    },
    {
        id: 'payment',
        title: 'Payment Gateways',
        description: '(Stripe, Razorpay, etc.)',
        icon: <CreditCard size={32} className="option-icon" />
    },
    {
        id: 'audio_video',
        title: 'Audio/Video Calls Integration',
        description: '',
        icon: <PhoneCall size={32} className="option-icon" />
    },
    {
        id: 'other',
        title: 'Other',
        description: 'Other',
        icon: <Plus size={32} className="option-icon" />
    }
];

const budgetRanges = [
    {
        id: 'lt_5000',
        title: 'Less than $5,000',
        icon: <DollarSign size={32} className="option-icon" />,
    },
    {
        id: '5000_10000',
        title: '$5,000 - $10,000',
        icon: <Coins size={32} className="option-icon" />,
    },
    {
        id: '10000_20000',
        title: '$10,000 - $20,000',
        icon: <CreditCard size={32} className="option-icon" />,
    },
    {
        id: 'gt_20000',
        title: 'More than $20,000',
        icon: <Wallet size={32} className="option-icon" />,
    },
];

export const steps = [
    {
        
        key: 'platform',
        label: 'What type of platform do you want to build?',
        subtitle: 'Choose the platform that best suits your project needs (Single Select)',
        type: 'single',
        options: platforms,
        required: true,
    },
    {
        key: 'industry',
        label: 'Which industry does your requirements belong to?',
        subtitle: 'Select the industry that best matches your project needs (Single Selection)',
        type: 'single',
        options: industries,
        required: true,
    },
    {
        key: 'services',
        label: 'Which of the following services do you require?',
        subtitle: 'Select the services that best match your project needs (Multi Select)',
        type: 'multi',
        options: services,
        required: true,
    },
    {
        key: 'devices',
        label: 'Should your web app be responsive across all devices?',
        subtitle: 'Select the devices your web app should support (Multi Select)',
        type: 'multi',
        options: devices,
        required: true,
    },
    {
        key: 'mobile_devices',
        label: 'Which mobile devices do you want to support?',
        subtitle: 'Select the mobile devices you want to support (Multi Select)',
        type: 'multi',
        options: mobileAppDevices,
        required: true,
    },
    {
        key: 'features',
        label: 'What core features do you need in your app or web platform?',
        subtitle: 'Select the features that best match your project needs (Multi Select)',
        type: 'multi',
        options: features,
        required: true,
        allowOther: true,
    },
    {
        key: 'integrations',
        label: 'Are there any third-party integrations you need?',
        subtitle: 'Select the integrations you need for your project (Multi Select)',
        type: 'multi',
        options: integrations,
        required: true,
        allowOther: true,
    },
    {
        key: 'budget',
        label: 'What is your estimated budget range?',
        subtitle: 'Select the budget range that best fits your project scope (Single Selection)',
        type: 'single',
        options: budgetRanges,
        required: true,
    },
    {
        key: 'nda',
        label: 'Do you require NDA before sharing details?',
        subtitle: 'Please indicate if you need a Non-Disclosure Agreement',
        type: 'boolean',
        required: false,
        info: 'An NDA (Non-Disclosure Agreement) is a legal contract that establishes confidentiality between parties, protecting sensitive information shared during the project.'
    },
    {
        key: 'project_vision',
        label: 'What\'s the vision behind your project?',
        subtitle: 'Share your goals, inspiration, and any supporting files to help bring your idea to life.',
        type: 'text',
        required: true,
    },
    {
        key: 'attachments',
        label: 'How can we reach you?',
        subtitle: 'Provide your contact information so we can stay connected throughout the project.',
        type: 'question',
        required: true,
        allowOther: true,
    },
    {
        key: 'otp_verification',
        label: 'Secure your submission with verification',
        subtitle: 'Complete OTP verification to confirm your identity and protect your data',
        type: 'otp',
        required: true,
    },
    {
        key: 'otp_code',
        label: 'Enter verification code',
        subtitle: 'We’ve sent a 6-digit code to your email',
        type: 'otp_code',
        required: true,
    }
];